<template>
  <div class="vue-toast-container">
    <Teleport to="#vue_toast_apps_container">
      <ToastContent
        v-for="[index, toast] of toasts"
        v-bind="toast"
        :key="index"
        @close="closeToast(index)"
      />
    </Teleport>
  </div>
</template>

<script>
import ToastContent from './ToastContent.vue'
import { addToastToMapWithUniqueId } from '../helpers/toast_helpers'

export default {
  name: 'BaseToast',
  components: {
    ToastContent,
  },
  data() {
    return {
      toasts: new Map(),
    }
  },
  created() {
    this.initToastEventHandler()
  },
  methods: {
    closeToast(index) {
      this.toasts.delete(index)
    },
    initToastEventHandler() {
      this.$emitter.on('toast', (toast) => {
        addToastToMapWithUniqueId(toast, this.toasts)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.vue-toast-container {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
</style>
